import { PATH_PREFIX } from 'routes/routes';

const APILink = {
  FIREBASE_TOKEN: `${PATH_PREFIX}/firebase/token`,
};

export default APILink;
